import * as z from "zod/v4";

export const getSessionDetails = {
  name: "getSessionDetails" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ onboardingDataSnapshot: z.any().nullable() }),
};

export type GetSessionDetailsInput = z.infer<typeof getSessionDetails.input>;
export type GetSessionDetailsOutput = z.infer<typeof getSessionDetails.output>;
